import { styled } from 'styled-components';
import { ThemeProps } from '../../themes/theme';

export interface StateIndicatorProps {
    disabled?: boolean;
    checked?: boolean;
}

export const Container = styled.label<ThemeProps<{ $fillContainer: boolean }>>`
    display: flex;
    ${(props) => (props.$fillContainer ? 'flex: 1 1;' : '')}
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-weight: 400;
    font-size: ${(props) => props.theme.spacing(3.5)};
    line-height: ${(props) => props.theme.spacing(4.5)};
`;

export const Input = styled.input`
    margin-right: ${(props) => props.theme.spacing(2)};
`;

export const Span = styled.span`
    margin-right: ${(props) => props.theme.spacing(0.5)};
`;
